import React from 'react';
import {
  components as ReactSelectComponents,
  GroupBase,
  MenuProps,
} from 'react-select';
import { IFieldValueDataRefreshProps } from './types';
import FieldValueDataRefresh from './FieldValueDataRefresh';

export const createRefreshableMenuComponent = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  fieldValueDataRefreshProps: IFieldValueDataRefreshProps,
) => {
  return ({ children, ...props }: MenuProps<Option, IsMulti, Group>) => (
    <ReactSelectComponents.Menu {...props}>
      {children}
      {fieldValueDataRefreshProps.field.pfv.refreshable && (
        <FieldValueDataRefresh {...fieldValueDataRefreshProps} />
      )}
    </ReactSelectComponents.Menu>
  );
};
